/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { patchedStaffRequestSchema } from "./patchedStaffRequestSchema.ts";
import { staffSchema } from "./staffSchema.ts";

export const orgOrganizationStaffPartialUpdatePathIdSchema = z.uuid();

export const orgOrganizationStaffPartialUpdatePathOrganizationIdSchema = z.uuid();

export const orgOrganizationStaffPartialUpdateStatus200Schema = staffSchema;

export const orgOrganizationStaffPartialUpdateResponseSchema = orgOrganizationStaffPartialUpdateStatus200Schema;

export const orgOrganizationStaffPartialUpdateDataSchemaJson = patchedStaffRequestSchema.optional();

export const orgOrganizationStaffPartialUpdateDataSchemaXml = patchedStaffRequestSchema.optional();

export const orgOrganizationStaffPartialUpdateDataSchema = z.union([
	orgOrganizationStaffPartialUpdateDataSchemaJson,
	orgOrganizationStaffPartialUpdateDataSchemaXml,
]);
